"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LtoCardWithIntlProvider = exports.LtoCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _uxUtils = require("@site/ux-utils");
var _utils = require("@site/utils");
var _buttons = require("@site/buttons");
var _RtbBlock = require("../RtbBlock");
var _sharedComponents = require("@site/shared-components");
var _AvailableTag = _interopRequireDefault(require("../AvailableCard/AvailableTag"));
var _CommonCardHeader = require("../common/CommonCardHeader");
var _LtoCard = _interopRequireDefault(require("../styles/LtoCard"));
var _PremiumSupportPhone = _interopRequireDefault(require("../PremiumSupportPhone"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const LtoCard = ({
  availableDomain,
  availableDomainProduct,
  availableDomainSource,
  privateLabelId,
  eidBase = '',
  tagTextId = '',
  premiumColorSchema,
  dataCy = 'ltoCard',
  alignment = 'start',
  useBlackAtcButton,
  cardHeader,
  cardClassNameOverrides = {},
  leaseToOwnFeatureData,
  AddToCartButton = _buttons.AvailableAddToCartButton,
  buttonProps = {},
  rtbBlockProps,
  premiumTagBoosted = {},
  auctionPhone,
  premiumPhone,
  showLtoTag,
  ltoInCart
}) => {
  const EID_CODES = (0, _utils.getEidCodes)(eidBase);
  const deviceType = (0, _uxUtils.useDeviceType)();
  const {
    isMobile,
    isDesktop,
    isTablet
  } = deviceType;
  const buyButtonClassNames = (0, _classnames.default)('px-4', {
    'button-primary-custom-color': !useBlackAtcButton,
    'pl-5 pr-5': buttonProps && isDesktop,
    [buttonProps?.buyButtonClassNames]: buttonProps?.buyButtonClassNames
  });
  const {
    backgroundColor
  } = cardClassNameOverrides;
  const {
    paymentPrice,
    numPayments
  } = (0, _react.useContext)(_sharedComponents.LeaseToOwnDataContext);
  const currency = (0, _utils.getCurrency)();
  const {
    isTaken,
    isAvailable,
    isAftermarketPremium,
    isAuction,
    isRegPremium,
    renderAsPremium
  } = (0, _utils.getExactMatchAvailable)(availableDomain, availableDomainProduct);
  const {
    itc
  } = (0, _utils.getIscAndItc)();
  (0, _react.useEffect)(() => {
    const exactMatchItc = (0, _utils.getItcExactMatch)({
      isAftermarketPremium,
      isRegPremium,
      isAuction,
      isTaken,
      isAvailable,
      domainSource: availableDomainSource,
      itc
    });
    const domainEidPrefix = (0, _utils.getDomainEidPrefix)({
      isAftermarketPremium,
      isAuction
    });
    isAftermarketPremium && (0, _utils.logImpression)(EID_CODES.LeaseNow.Premium);
    isAuction && (0, _utils.logImpression)(EID_CODES.LeaseNow.Auction);
    (0, _utils.logSearchTermImpression)({
      domainEntity: availableDomain,
      exactMatchItc,
      findKey: 'dpp_search',
      eidPrefix: `${EID_CODES.NewExactMatch}${domainEidPrefix}_${EID_CODES.LeaseNow.Impression}`,
      currency
    });
  }, []);
  const wrapperClasses = (0, _classnames.default)(`d-flex ux-card card-border-radius mb-0 justify-content-${alignment} lto-card-div`, {
    'flex-column justify-content-center position-relative': isMobile,
    'w-100 h-100': !isMobile,
    'bg-white': !backgroundColor,
    [backgroundColor]: backgroundColor
  });
  const contentWrapperClasses = (0, _classnames.default)(`d-flex flex-column align-items-${alignment}`, {
    'p-3 mt-4 mb-4 justify-content-center': isMobile,
    'p-5 w-100': !isMobile
  });
  const ltoFormattedPrice = () => /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    className: "d-flex align-items-center ms-1",
    id: "pricing.display.price-per-month",
    values: {
      price: /*#__PURE__*/_react.default.createElement("span", {
        className: "ms2 mb-0"
      }, paymentPrice)
    }
  });
  const sharedDomainProps = {
    isDesktop,
    extensionColorClassName: (0, _classnames.default)({
      'text-purple': renderAsPremium && !premiumColorSchema,
      'text-primary-o': !renderAsPremium && useBlackAtcButton && !premiumColorSchema,
      'text-primary': !renderAsPremium && !useBlackAtcButton && !premiumColorSchema
    }),
    textClassName: (0, _classnames.default)({
      'font-weight-bold mb-0': !isMobile
    })
  };
  const twoToneDomainProps = {
    ...sharedDomainProps,
    names: [availableDomain.NameWithoutExtension],
    extensions: [availableDomain.Extension],
    customColor: premiumColorSchema?.twoToneDomainColor
  };
  const boostedAftermarketEnabled = premiumTagBoosted && availableDomain?.IsBoostedAftermarket;
  const {
    badgeIcon = null,
    showBoostedTagIcon = false,
    boostedTagTextId,
    boostedTagTextValues,
    boostedTagTooltip,
    boostedTagColor,
    boostedTagSingleConsolidated
  } = boostedAftermarketEnabled ? premiumTagBoosted : {};
  const boostedAftermarketProps = {
    ...(badgeIcon && {
      tagIcon: (0, _uxUtils.getIcon)({
        icon: badgeIcon,
        iconSize: 18,
        className: 'mr-1'
      })
    }),
    ...(showBoostedTagIcon && {
      boostedTagIcon: (0, _uxUtils.getIcon)({
        icon: 'ok',
        iconSize: 18,
        className: boostedTagTextId && 'mr-1'
      })
    }),
    boostedTagTextId,
    boostedTagTextValues,
    boostedTagTooltip,
    boostedTagSingleConsolidated,
    boostedTagColor
  };
  return /*#__PURE__*/_react.default.createElement(_LtoCard.default, null, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": dataCy,
    className: wrapperClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: contentWrapperClasses,
    "data-cy": "ltoCard",
    "data-testid": "ltoCard"
  }, cardHeader && /*#__PURE__*/_react.default.createElement(_CommonCardHeader.CommonCardHeader, {
    headerTextId: cardHeader?.headerTextId,
    headerPrice: ltoFormattedPrice()
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex w-100"
  }, /*#__PURE__*/_react.default.createElement(_AvailableTag.default, (0, _extends2.default)({
    isTagVisible: true,
    tagTextId: tagTextId,
    tagTextValues: {
      percent: ''
    },
    isAfterMarketDomain: renderAsPremium,
    isAuctionDomain: isAuction,
    isDesktop: isDesktop,
    isMobile: isMobile,
    premiumColorSchema: premiumColorSchema,
    domainSource: availableDomainSource
  }, boostedAftermarketProps, {
    isLtoDomain: showLtoTag
  }))), /*#__PURE__*/_react.default.createElement(_sharedComponents.TwoToneDomain, twoToneDomainProps), /*#__PURE__*/_react.default.createElement(_sharedComponents.LeaseToOwnPicker, {
    exactMatchDomain: availableDomain,
    leaseToOwnFeatureData: leaseToOwnFeatureData,
    eidBase: eidBase,
    isCardLayout: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex w-100 align-items-center pt-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement(AddToCartButton, (0, _extends2.default)({
    domain: availableDomain,
    product: availableDomainProduct,
    plid: privateLabelId,
    buttonClassNameOverride: buyButtonClassNames,
    isMobile,
    numPayments,
    ltoInCart,
    isCardLayout: true
  }, buttonProps))), isDesktop && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'd-flex flex-column align-items-center pt-2': isMobile,
      'mt-1': isTablet,
      'align-items-center': isDesktop
    })
  }, /*#__PURE__*/_react.default.createElement(_PremiumSupportPhone.default, {
    isAuctionDomain: isAuction,
    cssClasses: 'text-muted ms-1 ml-1',
    auctionPhone: auctionPhone,
    premiumPhone: premiumPhone
  }))), rtbBlockProps && /*#__PURE__*/_react.default.createElement(_RtbBlock.RtbBlock, rtbBlockProps))));
};
exports.LtoCard = LtoCard;
LtoCard.propTypes = {
  availableDomain: _propTypes.default.object.isRequired,
  availableDomainProduct: _propTypes.default.object.isRequired,
  availableDomainSource: _propTypes.default.string.isRequired,
  privateLabelId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  eidBase: _propTypes.default.string,
  tagTextId: _propTypes.default.string,
  premiumColorSchema: _propTypes.default.object,
  dataCy: _propTypes.default.string,
  alignment: _propTypes.default.string,
  useBlackAtcButton: _propTypes.default.bool,
  language: _propTypes.default.object,
  cardHeader: _propTypes.default.shape({
    headerTextId: _propTypes.default.string
  }),
  cardClassNameOverrides: _propTypes.default.shape({
    backgroundColor: _propTypes.default.string
  }),
  leaseToOwnFeatureData: _propTypes.default.shape({
    data: _propTypes.default.shape({
      learnMoreText: _propTypes.default.string,
      tooltipContent: _propTypes.default.string,
      serviceFees: _propTypes.default.arrayOf(_propTypes.default.shape({
        minValueRange: _propTypes.default.number,
        maxValueRange: _propTypes.default.number,
        percentage: _propTypes.default.number
      })),
      defaultTermLengthOverride: _propTypes.default.number
    })
  }),
  ltoInCart: _propTypes.default.shape({
    paymentTerm: _propTypes.default.number
  }),
  buttonProps: _propTypes.default.shape({
    addToCartText: _propTypes.default.string,
    verifyingText: _propTypes.default.string,
    removeFromCartText: _propTypes.default.string,
    removingFromCartText: _propTypes.default.string
  }),
  rtbBlockProps: _propTypes.default.shape(_RtbBlock.RtbBlock.propTypes),
  auctionPhone: _propTypes.default.string,
  premiumPhone: _propTypes.default.string,
  showLtoTag: _propTypes.default.bool,
  isAftermarketPremiumDomain: _propTypes.default.bool,
  isRegPremiumDomain: _propTypes.default.bool
};
const LtoCardWithIntlProvider = ({
  language,
  ...props
}) => {
  const market = (0, _utils.getMarket)();
  const {
    languageStrings
  } = (0, _sharedComponents.useComponentDataProvider)(language);
  return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    messages: languageStrings
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.LeaseToOwnDataContextProvider, props, /*#__PURE__*/_react.default.createElement(LtoCard, (0, _extends2.default)({}, props, {
    language: languageStrings
  }))));
};
exports.LtoCardWithIntlProvider = LtoCardWithIntlProvider;
LtoCardWithIntlProvider.propTypes = {
  ...LtoCard.propTypes,
  ltoInCart: _propTypes.default.shape({
    domainName: _propTypes.default.string,
    packageId: _propTypes.default.string,
    paymentTerm: _propTypes.default.number
  }),
  language: _propTypes.default.object
};
const LtoCardWithComponentDataProvider = props => {
  const {
    appName,
    apiKey,
    forceEnableBFF,
    enableFavorites = true,
    privateLabelId = 1,
    urlOverride = 'godaddy.com',
    uipProps
  } = props;
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.ComponentDataProvider, (0, _extends2.default)({
    componentName: "cards",
    appName: appName,
    apiKey: apiKey,
    forceEnableBFF: forceEnableBFF
  }, enableFavorites && {
    uipProps: {
      plid: privateLabelId,
      urlOverride,
      ...uipProps
    }
  }), /*#__PURE__*/_react.default.createElement(LtoCardWithIntlProvider, props));
};
LtoCardWithComponentDataProvider.propTypes = {
  ...LtoCardWithIntlProvider.propTypes,
  uipProps: _propTypes.default.object,
  apiKey: _propTypes.default.string.isRequired,
  appName: _propTypes.default.string.isRequired,
  urlOverride: _propTypes.default.string.isRequired,
  forceEnableBFF: _propTypes.default.bool
};
var _default = exports.default = LtoCardWithComponentDataProvider;